import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Clock, Sparkles } from "lucide-react";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import ReviewBadges from "@/components/ReviewBadges";
import RoiCalculator from "@/components/RoiCalculator";
import { Button } from "@/components/ui/button";

const STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name: "TradeOff ROI Calculator",
  applicationCategory: "BusinessApplication",
  url: "https://tradeoff.blueshuckconsulting.com/roi",
  description: "Work out how much time and money AI takeoff and estimating could save your subcontracting business with TradeOff.",
  offers: { "@type": "Offer", price: "0", priceCurrency: "GBP" },
};

const Roi = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="bg-white" data-testid="roi-page">
      <Seo
        title="ROI Calculator — How Much Could AI Takeoff Save You? | TradeOff"
        description="See how much time and money TradeOff's AI takeoff and estimating could save your UK subcontracting business. Adjust it to your own numbers — free to try, no card."
        path="/roi"
        jsonLd={STRUCTURED_DATA}
      />
      <MarketingNav />

      <section className="relative border-b border-slate-200">
        <div className="absolute inset-0 grid-bg opacity-70" />
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10 text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">
            <Sparkles className="h-3.5 w-3.5" /> ROI calculator
          </span>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 leading-[1.08]">
            How much could TradeOff save you?
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl mx-auto">
            Estimating and re-keying eats evenings. Drag the sliders to your own numbers and see the time and money AI takeoff could give you back.
          </p>
        </div>
      </section>

      <section className="py-12 bg-slate-50">
        <div className="px-4 sm:px-6 lg:px-8">
          <RoiCalculator />
          <div className="mt-10 flex flex-col items-center gap-4">
            <ReviewBadges />
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Clock className="h-4 w-4" /> A takeoff that took hours now takes minutes.
            </div>
          </div>
        </div>
      </section>

      <section className="py-16" style={{ backgroundColor: "#16305C" }}>
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="font-display text-3xl font-bold text-white">Stop pricing after hours</h2>
          <p className="mt-4 text-slate-300">Try it free on a real drawing — there's even a demo project set up and waiting.</p>
          <Button size="lg" onClick={() => navigate("/register")} data-testid="roi-page-cta" className="mt-8 h-12 px-8 bg-blue-600 hover:bg-blue-500 text-base">
            Create your workspace <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Roi;
